'use client';

import { ClearIcon, SearchIcon } from '@/_assets/icon-components';
import { Box, Flex, IconButton, Input } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { useQueryState } from 'nuqs';
import { useRef } from 'react';

const RestaurantSearch = () => {
  const t = useTranslations();
  const [search, setSearch] = useQueryState('search', { defaultValue: '' });
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <Flex position='relative' width='100%' alignItems='center'>
      <Box
        pl={4}
        zIndex={2}
        display='flex'
        alignItems='center'
        position='absolute'
      >
        <SearchIcon w='20' h='20' color='#333' />
      </Box>
      <Input
        border='none'
        ref={inputRef}
        value={search}
        height={{ base: '40px', md: '48px' }}
        rounded={{ base: 'xl', lg: 'full' }}
        paddingLeft='48px'
        placeholder={t('search_in_eats')}
        backgroundColor='gray.400'
        _placeholder={{ color: 'text.muted' }}
        onChange={(e) => setSearch(e.target.value)}
        _focus={{ borderColor: 'transparent', outline: 'none' }}
      />
      <IconButton
        variant='plain'
        size='sm'
        position='absolute'
        right='8px'
        onClick={() => {
          setSearch('');
          inputRef.current?.focus();
        }}
        aria-label='Clear search'
        zIndex={2}
        visibility={search ? 'visible' : 'hidden'}
        opacity={search ? 1 : 0}
        transition='opacity 0.2s ease-in-out'
      >
        <ClearIcon />
      </IconButton>
    </Flex>
  );
};

export default RestaurantSearch;
